import { observer } from 'mobx-react';
import moment from 'moment';
import { DATE_YMD, MSG } from '../../../core/configs/constants';
import { useEffect } from 'react';
import { useStore } from '../../../core/utils/hook';
import yup from '../../../core/utils/yupValidate';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { ReactNotifications } from '../../../components';

const SettingQuestionModal = observer(({ id, name, deadline, question, fetchData, readOnly }) => {
    // validate form
    const validateSchema = yup.object().shape({
        question: yup.string().required(MSG['error.required'])
    })

    const { 
        register, handleSubmit,
        formState: { errors, isSubmitting }, reset 
    } = useForm({resolver: yupResolver(validateSchema), mode: 'onChange'});

    // store
    const {
        modalStore: { hide, openWarningModal },
        courseStore: { submitTrainingCourseQuestion }
    } = useStore();

    // lifecycle
    useEffect(() => {
        if (question) {
            reset({ question })
        }
    }, [question])

    // function
    const onSubmit = (data) => {
        openWarningModal(MSG['warning.student.add_question'], () => {
            handleSubmitData(data);
        }, '確認', 'small', '送信', '戻る')
    }

    const handleSubmitData = async (data) => {
        const result = await flowResult(submitTrainingCourseQuestion(id, data));
        if (result) {
            fetchData && fetchData();
            ReactNotifications('success', MSG['inform.success.update']);
            hide();
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='setting-question-modal'>
            <div className='pd-20'>
                {
                    name && (
                        <div className='row'>
                            <div className='col-3'>講座名</div>
                            <div className='col-9'>{name}</div>
                        </div>
                    )
                }
                {
                    deadline && (
                        <div className='row mg-t-10'>
                            <div className='col-3'>質問追加期限</div>
                            <div className='col-9'>{moment(deadline).format(DATE_YMD)}</div>
                        </div>
                    )
                }
                <div className='row mg-t-10'>
                    <div className='col-3 d-flex flex-gap-5'>講座内容への質問</div>
                    <div className='col-9'>
                        <textarea className='resize-none' {...register('question')} maxLength={2000} disabled={readOnly} />
                        {
                            errors?.question && (
                                <div className='text-danger mg-t-5'>{errors.question?.message}</div>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center align-items-center flex-gap-30 pd-tb-10'
                style={{ borderTop: '1px solid #d3d3d3' }}>
                <button type='button' className='btn btn-default-1 cancel-button min-width-120' onClick={() => {
                    if (readOnly) {
                        hide();
                    } else {
                        openWarningModal(MSG['warning.student.delete_question'], () => {
                            hide();
                        })
                    }
                }}>{readOnly ? '閉じる' : '削除'}</button>
                {
                    !readOnly && (
                        <button 
                            type='submit'
                            disabled={isSubmitting}
                            className='btn btn-default-3 min-width-120'>
                            質問する 
                        </button>
                    )
                }
            </div>
        </form>
    )
});

export default SettingQuestionModal;